import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Filter } from './filtering.interface';
import { Observable } from 'rxjs/internal/Observable';

@Injectable()
export class FilteringService {
  _filters = new BehaviorSubject<Filter[]>([]);
  filters: Observable<any>  = this._filters.asObservable();

  get (): Filter[] {
    return this._filters.getValue();
  }

  set (filters: Filter[]) {
    this._filters.next(filters);
  }
}
